import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle } from '../../../ui/icons/icons';

const ProfileStatusUpdate: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock API call to update status
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [token]);

  return (
    <div className='min-h-screen bg-slate-50 flex items-center justify-center p-4'>
      <div className='max-w-md w-full bg-white rounded-3xl shadow-xl shadow-slate-200/60 p-8 text-center animate-fade-in'>
        { loading ? (
          <div className='flex flex-col items-center gap-4'>
            <div className='w-12 h-12 border-4 border-emerald-500/20 border-t-emerald-500 rounded-full animate-spin'></div>
            <p className='text-slate-600 font-medium'>Updating your profile...</p>
          </div>
        ) : (
          <div className='flex flex-col items-center gap-6'>
            <div className='w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center'>
              <div className='w-10 h-10 text-emerald-500'>
                <CheckCircle />
              </div>
            </div>
            <div className='space-y-2'>
              <h1 className='text-2xl font-bold text-slate-900'>Status Updated</h1>
              <p className='text-slate-600 leading-relaxed'>
                We have updated your profile to <span className='font-bold text-slate-800'>NOT AVAILABLE</span> for future roles.
              </p>
            </div>
            <p className='text-sm text-slate-400'>
              You can update your profile at any time by logging into your account.
            </p>
            <button
                onClick={() => window.location.href = '/login'}
                className='mt-4 w-full py-3 bg-emerald-600 text-white rounded-xl font-semibold hover:bg-emerald-700 transition-colors shadow-lg shadow-emerald-200'
            >
              Go to Login
            </button>
          </div>
        ) }
      </div>
    </div>
  );
};

export default ProfileStatusUpdate;
